import { Pipe, PipeTransform } from '@angular/core';
import { EventKey, EventKeyHelper } from '../../model/user/enums/event-key-enum';

@Pipe({
    standalone: true,
    name: 'notificationEventIcon',
})
export class NotificationIconPipe implements PipeTransform {
    transform(value: EventKey): string {
        return EventKeyHelper.getEventKeyIcon(value);
    }
}
